/* eslint-disable max-len */

import premiumMassageImages from '../static/images/massage/premium-massage'

const {
  fiveStarReflexology,
  fullSpaBodyMassageAndCreambath,
  fullSpaBodyMassageAndKerokan,
  fullSpaBodyMassageAndLuluran,
  fullSpaBodyMassage,
  hotStoneSpaMassage,
  pregnancyMassage,
  serenitySpaReflexolgyAndBodyMassage,
  dryCupping,
  momBabyMassage,
  sprainMassage,
  totokWajah
} = premiumMassageImages

const premiumMessageServices = [
  {
    id: 1,
    show: false,
    title: 'Full Spa Body Massage',
    description:
      'Pijatan Relaksasi dgn Teknik Pijatan dasar tradisional Spa dikombinasikan teknik pijat modern penekanan di titik tubuh bagian kaki hingga kepala menghilangkan seluruh pegal pegal.',
    image: fullSpaBodyMassage,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Full Spa Body Massage',
    descriptionService:
      'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan special pure aromaterapi minyak esensial organik akan menenangkan, menghilangkan stres, dan mengurangi kecemasan.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Oil / Lotion / hot cream'
      },
      {
        id: 7,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '90,120,150,180  menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
      },
      {
        id: 2,
        title:
          'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern yang dilakukan pada posisi duduk hingga tidur dengan penekanan titik tubuh bagian kaki hingga ke bagian pungung,tangan dan kepala.'
      },
      {
        id: 3,
        title: 'Penyegaran tubuh dengan massage oil aromateraphy yang hangat.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 4,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 2,
    show: false,
    title: 'Serenity Spa Reflexolgy & Body massage',
    description:
      'Relaksasi pijat tradisional Spa dgn tambahan teknik refleksi kaki, Menghilangkan pegal menenangkan pikiran, dan meningkatkan kualitas tidur.',
    image: serenitySpaReflexolgyAndBodyMassage,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Serenity Spa Reflexolgy & Body Massage',
    descriptionService:
      'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan special pure aromaterapi minyak esensial organik akan menenangkan, menghilangkan stres, dan mengurangi kecemasan.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Oil / Lotion / hot cream'
      },
      {
        id: 7,
        title: 'Foot backet'
      },
      {
        id: 8,
        title: 'Bath salt'
      },
      {
        id: 9,
        title: 'Foot balm'
      },
      {
        id: 10,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '90,120,150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Merupakan terapi pijat yang mengombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh dan tangan, menjaga kualitas tubuh kamu menenangkan pikiran, dan meningkatkan kualitas tidur.'
      },
      {
        id: 2,
        title:
          'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
      },
      {
        id: 3,
        title:
          'Penyegaran tubuh dengan massage oil aromateraphy yang hangat dan perawatan kaki.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja reflexology dan massage.'
      },
      {
        id: 2,
        title:
          'Pelanggan disarankan untuk menyiapkan air hangat untuk treatment kaki.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 4,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 5,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 3,
    show: false,
    title: 'Five Star Reflexology',
    description:
      'Penekanan pada pijatan reflex dikaki dan kombinasi dengan perawatan kaki dengan tambahan pijatan ringan dibeberapa bagian tubuh hingga kepala.',
    image: fiveStarReflexology,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: '5 Star Reflexology',
    descriptionService:
      'Kaki anda juga layak untuk dimanja, rasakan pengalaman sensasi pelayanan bintang 5, Manjakan diri Anda dengan merendam dan merawat kaki anda dengan pijatan titik kaki yang akan bermanfaat mereales tubuh anda yang meningkatkan kebugaran dan kesehatan.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Foot backet'
      },
      {
        id: 2,
        title: 'Bath salt'
      },
      {
        id: 3,
        title: 'Foot balm'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Aromatherapy difusser'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '60,90,menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Merupakan perawatan relaksasi kaki, dimulai dengan merendam kaki anda dengan air hangat dipadukan dengan taburan bath salt yang bermanfaat untuk kulit kaki anda.'
      },
      {
        id: 2,
        title:
          'Melakukan Pijatan pada posisi duduk, dengan penekanan ringan pada bagian telapak dan tungkai hingga betis kaki dan kombinasi pijat titik kaki hingga ke pungung,tangan dan kepala.'
      },
      {
        id: 3,
        title:
          'Penyegaran kaki dengan Aplikasi pijatan ringan dengan pengunaan foot balm.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk peralatan kerja dan cream perawatan kaki'
      },
      {
        id: 2,
        title:
          'Pelanggan disarankan untuk menyiapkan air hangat sesuai kebutuhan'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk biaya transportasi home service'
      },
      {
        id: 4,
        title: 'Harga sudah termasuk Asuransi'
      },
      {
        id: 5,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 4,
    show: false,
    title: 'Full Spa Body Massage + kerokan',
    description:
      'Relaksasi Pijatan tradisional spa ditambah dengan tradisional treatment kerokaan untuk mengatasi gejala masuk angin untuk meningkatkan kesehatan.',
    image: fullSpaBodyMassageAndKerokan,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Full Spa Body Massage + Kerokan',
    descriptionService:
      'Berikan kesegaran pada tubuh Anda dengan pijatan yang akan merilekskan jaringan tubuh Anda yang lelah, sekaligus untuk mengatasi gejala masuk angin untuk meningkatkan kesehatan, Relaksasi Pijatan tradisional spa ditambah dengan tradisional treatment kerokaan untuk mengatasi gejala masuk angin untuk meningkatkan kesehatan.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Gpu Oil / hot cream'
      },
      {
        id: 7,
        title: 'Gua Sha tools'
      },
      {
        id: 8,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '120,150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Merupakan terapi pijat penenangan diri, untuk menghilangkan gejala masuk angin dan mengkombinasikan teknik pijat tradisional agar tubuh menjadi ringan dan sehat.'
      },
      {
        id: 2,
        title:
          'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik kerokan yang merangsang aliran energi dan meningkatkan penyembuhan.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title: 'Harga tertera sudah termasuk standart peralatan kerja.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 4,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 5,
    show: false,
    title: 'Full Spa Body Massage + Luluran',
    description:
      'Relaksasi Pijatan tradisional spa ditambah dengan treatment lulur/scrub untuk perawatan tubuh,mengangkat sel kulit mati dan melembabkan seluruh kulit.',
    image: fullSpaBodyMassageAndLuluran,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Full Spa Body Massage + Luluran',
    descriptionService:
      'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan juga perawatan kulit tubuh, dengan bahan organik, yang akan membantu menyegarkan tubuh dan mengeksfoliasi kulit tubuh kamu.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Oil / Lotion'
      },
      {
        id: 7,
        title: 'Foot balm'
      },
      {
        id: 8,
        title: 'Essensial Oil lavender / lemograss'
      },
      {
        id: 9,
        title: 'Varian Scrub / Boreh / Lulur'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
      },
      {
        id: 2,
        title:
          'Merupakan terapi pijat yang mengombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh ,tangan dan kepala mendorong kebugaran baru pada tubuh kamu.'
      },
      {
        id: 3,
        title:
          'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
      },
      {
        id: 4,
        title:
          'Treatment akhir selama 30-menit mengaplikasikan cream lulur/scrub/boreh untuk mengangkat sel kulit mati serta menyegarkan dan menghaluskan kulit tubuh.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja full body massage.'
      },
      {
        id: 2,
        title:
          'Harga termasuk lulur,boreh dan scrub yang dapat dipilih sesuai kebutuhan.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 4,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 5,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 6,
    show: false,
    title: 'Hot Stone Spa Massage',
    description:
      'Relaksasi pijatan klasik hydroterapi dengan menggunakan batu vulkanik,bermanfaat mengurangi stres dan kecemasan untuk menjaga kesehatan dan kebugaran.',
    image: hotStoneSpaMassage,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Hot Stone Spa Massage',
    descriptionService:
      'Relaksasi pijatan klasik hydroterapi dengan menggunakan batu vulkanik,bermanfaat mengurangi stres dan kecemasan untuk Meningkatkan fleksibilitas sendi dan otot tubuh serta Meningkatkan kualitas tidur.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Microfiber Towel'
      },
      {
        id: 4,
        title: 'Spa music speaker'
      },
      {
        id: 5,
        title: 'Aromatherapy difusser'
      },
      {
        id: 6,
        title: 'Hot stone & Heater Box'
      },
      {
        id: 7,
        title: 'Oil / Lotion'
      },
      {
        id: 8,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '120,150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
      },
      {
        id: 2,
        title:
          'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat yang memanfaatkan batu basal yang telah dipanaskan dan digerakan dengan teknik pijatan yang fokus pijatan pada beberapa titik tertentu tubuh.'
      },
      {
        id: 3,
        title:
          'Diakhiri dengan meletakan kehangatan batu di beberapa bagian tubuh seperti punggung dan pinggang, tangan, kaki, perut.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 4,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 7,
    show: false,
    title: 'Massage + Totok wajah & Masker',
    description:
      'Relaksasi Pijatan tradisional spa ditambah dengan totok wajah dan masker peel off, memperlancar peredaran darah membuat wajah cerah dan sehat.',
    image: totokWajah,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: ' Massage + Totok Wajah & Masker ',
    descriptionService:
      'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan juga fokus terhadap perawatan kulit wajah, dengan bahan organik, yang akan membantu menyegarkan serta mencerahkan kulit wajah.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Oil / Lotion'
      },
      {
        id: 7,
        title: 'Face cream'
      },
      {
        id: 8,
        title: 'Essensial Oil lavender / lemograss'
      },
      {
        id: 9,
        title: 'Varian Mask peel off organik'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage proses pijat mengunakan teknik pijatan 5 dasar  gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
      },
      {
        id: 2,
        title:
          'Totok wajah memadukan dua teknik acupressure & bioenergi tenaga yang fokus pada titik-titik tertentu pada wajah yang mendorong kelancaran aliran darah.'
      },
      {
        id: 3,
        title:
          'Treatment akhir selama 30-menit mengaplikasikan masker peel off untuk mengangkat sel kulit mati dan menghaluskan kulit wajah.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja full body massage.'
      },
      {
        id: 2,
        title:
          'Harga termasuk masker oragnik peel off yang dapat dipilih sesuai kebutuhan.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 4,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 5,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 8,
    show: false,
    title: 'Full Spa Body Massage + Creambath',
    description:
      'Relaksasi pijatan tradisonal dengan tambahan treatment rambut dan kulit kepala untuk melembapkan rambut yang kering,serta memberi nutrisi pada rambut.',
    image: fullSpaBodyMassageAndCreambath,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Full Spa Body Massage + Creambath',
    descriptionService:
      'Mengembalikan suasana hati dan menghilangkan stres dan ketegangan otot tubuh, dengan pijat tradisional kami sekaligus melakukan perawatan kulit kepala dan rambut, dengan bahan organik, memberikan kesegaran pada kulit kepala dengan pijatan yang akan merilekskan jaringan tubuh anda yang lelah.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Aromatherapy difusser'
      },
      {
        id: 7,
        title: 'Hair mask creambath'
      },
      {
        id: 8,
        title: 'Oil / Lotion'
      },
      {
        id: 9,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
      },
      {
        id: 2,
        title:
          'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern yang dilakukan pada posisi duduk hingga tidur dengan penekanan titik tubuh bagian kaki hingga ke bagian pungung,tangan dan kepala.'
      },
      {
        id: 3,
        title:
          'Teknik pijatan kepala selama 30 menit tekanan lembut  dengan mengerakan melingkar berulang kali kepada kepala dengan diakhiri mengaplikasikan hair mask .'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title:
          'Harga tertera sudah termasuk peralatan kerja dan cream perawatan kaki'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 3,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 9,
    show: false,
    title: 'Full Spa Body Massage + DryCupping',
    description:
      'Pijat relaksasi kesehatan untuk memperbaiki sistem Imun tubuh dan mengatasi gejala masuk angin, dengan alternatif penganti kerokan.',
    image: dryCupping,
    alertCard:
      'Pelanggan yang terhormat diskripsi layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.',
    titleService: 'Full Spa body massage + Dry Cupping',
    descriptionService:
      'Terapi pijat kesehatan untuk memperbaiki sistem Imun tubuh untuk mengatasi gejala masuk angin, dengan alternatif penganti kerokan, ditambah dengan pijatan yang akan merilekskan jaringan tubuh anda yang lelah, sekaligus untuk mengatasi  tubuh yang lelah dan membantu meningkatkan kesehatan tubuh.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Aromatherapy difusser'
      },
      {
        id: 4,
        title: 'Microfiber Towel'
      },
      {
        id: 5,
        title: 'Spa music speaker'
      },
      {
        id: 6,
        title: 'Oil / Lotion / hot cream'
      },
      {
        id: 7,
        title: 'Essensial Oil lavender / lemograss'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '150,180 menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
      },
      {
        id: 2,
        title:
          'Merupakan layanan relaxasi pijat yang mengkombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh ,tangan dan kepala mendorong kebugaran baru pada tubuh kamu.'
      },
      {
        id: 3,
        title:
          'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
      }
    ],
    standardEquimentTitle: 'Standart Peralatan Kerja:',
    standardEquimentDescription:
      'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan peralatan bekam (cup) yang mitra kami bawa selalu kami lakukan setrilasisi dengan pengunanaa mesin seterilisator dan dibasuh dengan alkhohol.',
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title: 'Harga tertera sudah termasuk standart peralatan kerja.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 4,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 10,
    show: false,
    title: 'Sprain Massage',
    description:
      'Perawatan khusus untuk otot atau persendian yang mengalami pembengkakan atau rasa sakit akibat keselo/terkilir (dilayani oleh teraphis specialisasi).',
    image: sprainMassage,
    alertCard: [
      'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan layanan dari teraphis specialisasi kami.',
      'Layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.'
    ],
    titleService: 'Sprain Massage',
    descriptionService:
      'Bertujuan untuk merenggangkan otot, mencegah cedera, mengatasi sakit terhadap otot terkilir. meningkatkan aliran darah ke area yang cedera sehingga dapat mempercepat proses pemulihan, dan kami melakukan terapi pijat toleransi hanya terhadap nyeri dan cidera ringan.',
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Premium mattras'
      },
      {
        id: 2,
        title: 'Disposible bed sheet'
      },
      {
        id: 3,
        title: 'Microfiber Towel'
      },
      {
        id: 4,
        title: 'Spa music speaker'
      },
      {
        id: 5,
        title: 'Oil / Lotion / hot cream'
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '90,120, menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Sprain massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat Perawatan khusus untuk otot atau persendian yang mengalami permasalahan pembengkakan atau rasa sakit akibat keselo/terkilir.'
      },
      {
        id: 2,
        title:
          'Mengunakan dua teknik cross-friction massage pijatan yang mencegah perlengketan jaringan luka yang terjadi di ligamen dan teknik pijatan limfatic untuk bertujuan mengurangi pembengkakan pada kaki yang terkilir.'
      }
    ],
    standardEquimentTitle: 'Standart Peralatan Kerja:',
    standardEquimentDescription:
      'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title: 'Harga tertera sudah termasuk standart peralatan kerja '
      },
      {
        id: 2,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 3,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 4,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 11,
    show: false,
    title: 'Pregnancy Massage',
    description:
      'Perawatan khusus untuk ibu hamil, tetapi untuk yang mengalami kendala atau memiliki keluhan tertentu disarankan untuk berkonsultansi terlebih dahulu dengan dokter Anda.',
    image: pregnancyMassage,
    alertCard: [
      'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan layanan dari teraphis specialisasi kami teraphis wanita.',
      'Layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.'
    ],
    titleService: 'Pregnancy Massage',
    descriptionService: [
      {
        id: 1,
        title: 'Prenatal massage',
        description:
          'perawatan dan relaxasi disarankan di atas usia 12 minggu meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, untuk melancarkan aliran darah ke seluruh tubuh dan janin, Menstabilkan hormon di dalam tubuh, baik kesehatan fisik dan psikis ibu hamil,dan mempersiapkan tubuh lebih baik menjelang hari persalinan.'
      },
      {
        id: 2,
        title: 'Postnatal Massage',
        description:
          'perawatan dan relaxasi untuk meningkatkan kebahagiaan. meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, pereda sakit, menstabilkan hormon serta menurunkan kadar hormon kortisol berlebihan saat pasca melahirkan agar ibu lebih relax.'
      }
    ],
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Disposible bed sheet'
      },
      {
        id: 2,
        title: 'Aromatherapy difusser'
      },
      {
        id: 3,
        title: 'Microfiber Towel'
      },
      {
        id: 4,
        title: 'Spa music speaker'
      },
      {
        id: 5,
        title: 'Special Oil  Organic'
      },
      {
        id: 6,
        title: 'Essensial Oil organik lavender '
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '90,120, menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Pregnancy  massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan pada ibu hamil dan pasca melahitkan untuk mengembalikan kebugaran tubuh  dan mood.'
      },
      {
        id: 2,
        title:
          'Mengabungkan pijatan oksitosin, dan laktasi  gerakan pijatan ringan dengan tekanan usapan lembut dan menyesuaikan dengan titik-titik tertentu yang diperbolehkan untuk dipijat saat hamil. dan dilakukan pada posisi duduk dan posisi berbaring menyamping.'
      },
      {
        id: 3,
        title:
          'Memfokuskan titik titik pijatan yang memahami kondisi pasca persalinan, baik itu untuk yang menjalani operasi atau melahirkan secara normal,pijatan dilakukan pada  seluruh tubuh ini melibatkan pembalutan perut dan juga payudara untuk mempelancar asi.'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 3,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      },
      {
        id: 4,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
      }
    ],
    shouldShowDetailWorkContent: true
  },
  {
    id: 12,
    show: false,
    title: 'Mom & Baby Spa Massage',
    description:
      'Perawatan dan relaksasi pijatan tradisional untuk Ibu dan anak bayi pasca melahirkan (dilayani oleh teraphis specialisasi )',
    image: momBabyMassage,
    alertCard: [
      'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan layanan dari teraphis specialisasi kami teraphis wanita',
      'Layanan ini berlaku hanya untuk layanan vendor premium kami, yang saat ini tersedia diwilayah jakarta.'
    ],
    titleService: 'Mom and Baby Massage',
    descriptionService: [
      {
        id: 1,
        title: 'Mom Massage',
        description:
          'perawatan dan relaxasi untuk meningkatkan kebahagiaan. meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, pereda sakit, menstabilkan hormon serta menurunkan kadar hormon kortisol berlebihan saat pasca melahirkan agar ibu lebih relax.'
      },
      {
        id: 2,
        title: 'Baby Massage',
        description:
          'Merupakan perawatan terapi relaksasi bayi dengan teknik pijat ringan untuk merangsang stimulasi positif.'
      }
    ],
    workStandardTitle: 'Standart Peralatan Kerja & Kompliment:',
    workStandardDescription: [
      {
        id: 1,
        title: 'Disposible bed sheet'
      },
      {
        id: 2,
        title: 'Aromatherapy difusser'
      },
      {
        id: 3,
        title: 'Microfiber Towel'
      },
      {
        id: 4,
        title: 'Baby Spa music speaker'
      },
      {
        id: 5,
        title: 'Special Oil  Organic'
      },
      {
        id: 6,
        title: 'Essensial Oil Organik lavender '
      }
    ],
    secondAlertCard:
      'Untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
    durationServiceTitle: 'Waktu Durasi Pilihan:',
    durationServiceDescription:
      '90,120, menit (sesuai dengan durasi layanan terpilih)',
    coverageServiceTitle: 'Cakupan Standart Layanan:',
    coverageServiceDescription: [
      {
        id: 1,
        title:
          'Mom massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan pada ibu hamil dan pasca melahitkan untuk mengembalikan kebugaran tubuh  dan mood.'
      },
      {
        id: 2,
        title:
          'Mengabungkan pijatan oksitosin, dan laktasi teknik pijatan ringan  untuk ibu yang memfokuskan titik titik pijatan yang memahami kondisi pasca persalinan,baik itu untuk yang menjalani operasi atau melahirkan secara normal,pijatan dilakukan pada  seluruh tubuh ini melibatkan pembalutan perut dan payudara mempelancar asi.'
      },
      {
        id: 3,
        title:
          'Teknik Baby massage pijatan ringan dengan cara mengusap atau mengelus tubuh bayi agar menimbulkan efek nyaman dan membantu relaksasi otot tubuh bayi'
      }
    ],
    termsOfServiceTitle: 'Ketentuan Layanan:',
    termsOfServiceDescription: [
      {
        id: 1,
        title: 'Harga sudah termasuk biaya transportasi home service.'
      },
      {
        id: 2,
        title: 'Harga sudah termasuk Asuransi.'
      },
      {
        id: 3,
        title:
          'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
      },
      {
        id: 4,
        title:
          'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
      }
    ],
    shouldShowDetailWorkContent: true
  }
]

export default premiumMessageServices
